import OfferCustomizedPage from './OfferCustomizedPage';

export default OfferCustomizedPage;
